/**
 * Simulator page — config only. Component in SimulatorPage.tsx so edits get Fast Refresh.
 */

import { FlaskConical } from "lucide-react"
import SimulatorPage from "./SimulatorPage"

export const simulator = {
  title: "Simulator",
  description: "Conversation simulation and testing",
  route: "/simulator",
  url: "/simulator",
  icon: FlaskConical,
  component: SimulatorPage,
  group: "evaluations",
  resource: "simulator",
  action: "read",
} satisfies PageConfig
